import React, { useState, useEffect, useRef, useCallback } from "react";
import { supabase } from "./supabaseClient";
import "./styles.css";

const clickSound = new Audio(
  "https://assets.mixkit.co/active_storage/sfx/2013/2013-preview.mp3"
);
const leaveSound = new Audio(
  "https://assets.mixkit.co/active_storage/sfx/204/204-preview.mp3"
);
const loginSound = new Audio("/drum.mp3");

const DATE_DEBLOCAGE_WA = new Date("2026-04-20T14:00:00").getTime();

export default function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [nom, setNom] = useState("");
  const [billet, setBillet] = useState("");
  const [monEquipeId, setMonEquipeId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [maintenant, setMaintenant] = useState(new Date().getTime());
  const [activeBeatIndex, setActiveBeatIndex] = useState(-1);

  // --- NOUVEAUX ÉTATS POUR LE LORE ---
  const [hoveredLore, setHoveredLore] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const audioRef = useRef(null);

  const [equipes, setEquipes] = useState([
    {
      id: 1,
      nom: "Flamencon/ifère",
      color: "#ff4b2b",
      membres: [],
      wa: "https://chat.whatsapp.com/FyqZiV9w6Z84uEAx9zS39g",
      lore: "Nés des cendres des vieux pins, ils dansent pour garder la forêt au chaud.",
    },
    {
      id: 2,
      nom: "Capoeiracine",
      color: "#a8ff78",
      membres: [],
      wa: "https://chat.whatsapp.com/JKA6d6t3QuqLgp2yaTQVTR",
      lore: "Leurs mouvements fluides puisent l'énergie directement dans l'humus sacré.",
    },
    {
      id: 3,
      nom: "Cha-cha-Cha'mpignon",
      color: "#fbd72e",
      membres: [],
      wa: "https://chat.whatsapp.com/Ji0TwpGrmTx9qsEIkXSxln",
      lore: "Discrets mais rythmés, ils communiquent par vibrations souterraines.",
    },
    {
      id: 4,
      nom: "Discocureuil",
      color: "#ff00cc",
      membres: [],
      wa: "https://chat.whatsapp.com/JrNQsYycMJvBlb73LApZ7L",
      lore: "Les gardiens des noisettes à facettes. Ils ne dorment jamais, ils brillent.",
    },
    {
      id: 5,
      nom: "Elfstorm",
      color: "#00d2ff",
      membres: [],
      wa: "https://chat.whatsapp.com/GyPzcIlt0pj5xIu766vCE6",
      lore: "Maîtres des vents et des mélodies aériennes, ils flottent au-dessus de la canopée.",
    },
    {
      id: 6,
      nom: "JosianePiChèvreFeuille",
      color: "#feb47b",
      membres: [],
      wa: "https://chat.whatsapp.com/JkE9bJoLolEAGCgZdmBd02",
      lore: "La douceur d'une infusion de minuit alliée à la force des racines anciennes.",
    },
    {
      id: 7,
      nom: "Mangroove",
      color: "#3a7bd5",
      membres: [],
      wa: "https://chat.whatsapp.com/D04PF0H0QXdDQXsHQGuEIC",
      lore: "Ils vivent là où l'eau rencontre la terre, au rythme des marées cosmiques.",
    },
    {
      id: 8,
      nom: "Paso Doblaireau",
      color: "#74ebd5",
      membres: [],
      wa: "https://chat.whatsapp.com/HO9Ct7rofgZBuMXgtcKeVB",
      lore: "Farouches et fiers, ils frappent le sol pour réveiller les esprits de la forêt.",
    },
    {
      id: 9,
      nom: "Rock'n'Rollivier",
      color: "#9ecdff",
      membres: [],
      wa: "https://chat.whatsapp.com/ILyFjHSfKz9788GCQHP7LT",
      lore: "Aussi solides que le bois centenaire, leurs riffs font trembler les montagnes.",
    },
    {
      id: 10,
      nom: "SalsaPin",
      color: "#00ff87",
      membres: [],
      wa: "https://chat.whatsapp.com/DxsM270pi1I2AFDlU5iNMu",
      lore: "Le piquant du conifère mélangé à la chaleur des rythmes tropicaux.",
    },
  ]);

  const maxPlaces = 30;

  useEffect(() => {
    if (!isAuth) return;
    const msPerBeat = (60 / 130) * 1000;
    const interval = setInterval(() => {
      setActiveBeatIndex((prev) => (prev + 1) % equipes.length);
    }, msPerBeat);
    return () => clearInterval(interval);
  }, [isAuth, equipes.length]);

  // --- LOGIQUE DE SUIVI DE SOURIS ---
  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  const triggerError = (msg) => {
    setErrorMessage(msg);
    setTimeout(() => setErrorMessage(""), 4000);
  };

  useEffect(() => {
    const timer = setInterval(() => setMaintenant(new Date().getTime()), 10000);
    return () => clearInterval(timer);
  }, []);

  // Lecture des inscriptions via la fonction serveur (nécessite un billet valide).
  // Ne renvoie aucun numéro de billet ; "is_me" repère notre propre ligne.
  const fetchInscriptions = useCallback(async () => {
    if (!billet) return;
    const { data, error } = await supabase.rpc("get_inscriptions", {
      p_billet: billet,
    });
    if (!error && data) {
      setEquipes((prev) =>
        prev.map((eq) => ({
          ...eq,
          membres: data
            .filter((d) => d.equipe_id === eq.id)
            .map((d) => d.nom),
        }))
      );
      const mine = data.find((d) => d.is_me);
      setMonEquipeId(mine ? mine.equipe_id : null);
    }
  }, [billet]);

  // Le temps réel est coupé par le RLS pour la clé publique : on rafraîchit
  // au chargement, après nos propres actions, et par sondage toutes les 15 s.
  useEffect(() => {
    fetchInscriptions();
    const poll = setInterval(fetchInscriptions, 15000);
    return () => clearInterval(poll);
  }, [fetchInscriptions]);

  const validerBillet = async () => {
    if (nom.length < 2 || billet.length < 3) {
      triggerError("Veuillez remplir votre nom et un billet valide.");
      return;
    }
    const numero = billet.trim();
    const { data, error } = await supabase.rpc("validate_billet", {
      p_numero: numero,
    });
    if (!error && data === true) {
      setBillet(numero);
      loginSound.play().catch(() => {});
      if (audioRef.current) {
        audioRef.current.volume = 0.3;
        audioRef.current.play().catch((e) => console.log("Lecture bloquée"));
      }
      setIsAuth(true);
    } else {
      triggerError("Billet non reconnu.");
    }
  };

  const rejoindre = async (id) => {
    if (monEquipeId) return;
    const { error } = await supabase.rpc("join_team", {
      p_billet: billet,
      p_nom: nom,
      p_equipe_id: id,
    });
    if (!error) {
      clickSound.play().catch(() => {});
      setMonEquipeId(id);
      fetchInscriptions();
    } else {
      triggerError(error.message || "Impossible de rejoindre cette guilde.");
    }
  };

  const quitter = async () => {
    const { error } = await supabase.rpc("leave_team", { p_billet: billet });
    if (!error) {
      leaveSound.play().catch(() => {});
      setMonEquipeId(null);
      fetchInscriptions();
    }
  };

  return (
    <div className="App" onMouseMove={handleMouseMove}>
      <audio ref={audioRef} src="/danse.mp3" loop />

      {/* --- FENÊTRE DE LORE (TOOLTIP) --- */}
      {hoveredLore && (
        <div
          className="lore-tooltip"
          style={{
            left: mousePos.x + 15,
            top: mousePos.y + 15,
            borderLeft: `4px solid ${hoveredLore.color}`,
          }}
        >
          <div className="lore-header">Lore de la Guilde</div>
          <p>{hoveredLore.text}</p>
        </div>
      )}

      {!isAuth ? (
        <div className="wow-overlay">
          {errorMessage && (
            <div className="wow-error-popup">
              <div className="wow-error-content">
                <span className="error-icon">⚠️</span>
                <span>{errorMessage}</span>
              </div>
            </div>
          )}
          <div className="wow-login-frame">
            <h1 className="main-title">OPAL</h1>
            <p className="event-subtitle">INSCRIPTION AU REGISTRE FORESTIER</p>
            <div className="wow-form-group">
              <label>PRÉNOM & NOM OU PSEUDO</label>
              <input
                type="text"
                className="wow-input"
                placeholder="Ex: Jérôme BESSELESSON"
                onChange={(e) => setNom(e.target.value)}
              />
            </div>
            <div className="wow-form-group">
              <label>NUMÉRO DE BILLET</label>
              <input
                type="text"
                className="wow-input"
                placeholder="HelloAsso"
                onChange={(e) => setBillet(e.target.value)}
              />
            </div>
            <button className="wow-button" onClick={validerBillet}>
              ENTRER DANS LA FORÊT
            </button>
          </div>
        </div>
      ) : (
        <div className="main-content">
          <header>
            <h1 className="main-title">OPAL</h1>
            <p className="event-subtitle">DANSE DE LA FORÊT</p>
            <div className="ornament">✦ ───────── ☾ ───────── ✦</div>
          </header>

          <div className="forest-grid">
            {equipes.map((e, index) => {
              const estMaTeam = monEquipeId === e.id;
              const totalMembres = e.membres.length;
              const estPleine = totalMembres >= maxPlaces;
              const tempsEcoule = maintenant > DATE_DEBLOCAGE_WA;
              const voirLienWA = estMaTeam && (estPleine || tempsEcoule);
              const isGlowing = activeBeatIndex === index;

              return (
                <div
                  key={e.id}
                  className={`guild-card ${estMaTeam ? "active" : ""} ${
                    isGlowing ? "beat-flash" : ""
                  }`}
                  style={{ "--guild-color": e.color }}
                  onMouseEnter={() =>
                    setHoveredLore({ text: e.lore, color: e.color })
                  }
                  onMouseLeave={() => setHoveredLore(null)}
                >
                  <h3>{e.nom}</h3>
                  <div className="slots-info">
                    <div className="count">
                      {totalMembres} / {maxPlaces} membres
                    </div>
                    <div className="progress-bar">
                      <div
                        style={{
                          width: `${(totalMembres / maxPlaces) * 100}%`,
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="guild-registry">
                    <p className="registry-title">Inscrits :</p>
                    <ul className="registry-list">
                      {totalMembres > 0 ? (
                        e.membres.map((m, idx) => (
                          <li key={idx} className={m === nom ? "is-me" : ""}>
                            {m} {m === nom ? "(Vous)" : ""}
                          </li>
                        ))
                      ) : (
                        <li className="empty">Aucun inscrit</li>
                      )}
                    </ul>
                  </div>

                  <div className="button-area">
                    {estMaTeam ? (
                      <div className="my-guild-controls">
                        <button
                          onClick={quitter}
                          className="btn-action btn-leave"
                        >
                          QUITTER LA GUILDE
                        </button>
                        {voirLienWA ? (
                          <div className="locked-success">
                            <p className="status-msg">
                              {estPleine ? "✨ COMPLÈTE !" : "🔓 ACCÈS OUVERT"}
                            </p>
                            <a
                              href={e.wa}
                              target="_blank"
                              rel="noreferrer"
                              className="wa-button animated"
                            >
                              REJOINDRE WHATSAPP
                            </a>
                          </div>
                        ) : (
                          <p className="waiting-msg">En attente...</p>
                        )}
                      </div>
                    ) : (
                      <button
                        onClick={() => rejoindre(e.id)}
                        disabled={monEquipeId !== null || estPleine}
                        className="btn-action"
                      >
                        {estPleine ? "PLEIN" : "REJOINDRE"}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
